<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in $staticParams.locales"
      :key="localeObj.locale"
      @click="changeLang(localeObj.locale)"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'
import store from '@/store'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.$staticParams.locales.find(l => l.locale === this.$i18n.locale)
    },
  },
  created() {
    const userData = JSON.parse(localStorage.getItem('userData'))
    this.$i18n.locale = userData.lang
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang; this.$moment.locale(lang)
      store.dispatch('app/changeLanguage', { lang })
        .then(() => {
        })
    },
  },
  setup() {
    /* eslint-disable global-require */

    /* eslint-disable global-require */

    return {

    }
  },
}
</script>

<style>

</style>
